$(document).ready(function() {
    $("div[id*='loox_reviews_loox_rating']").addClass('active_looks');
});

$(document).on('change', '.product-form__input input', function() {
  var selectedValue = $(this).val(); 
  var selectedName = $(this).attr('name');
  var selectedPrice = $(this).attr('var_price');
   var lowerName = selectedName.toLowerCase();
if($(this).hasClass('nochnage')){

}else{
    if (lowerName.includes('color')) {
    selectedName = 'Color';
  }



  $('legend[option_label]').html(selectedName + " : <span>" + selectedValue + "</span>"); 
    $('legend[option_label]').html(selectedName + " : <span>" + selectedValue + "</span>"); 
  $('.price_btn').text(selectedPrice);  
  }
});


$('.option-item').click(function() {
    $(this).closest('.bundle-info').find('.option-item').removeClass('active');
    $(this).addClass('active');
      let imgSrc = $(this).find('img').attr('src');
      let divColor = $(this).attr('style');
      let spanText = $(this).find('span').text();
      let spanTitle = $(this).closest('.bundle-info').find('.bundle-title').text();
    $(this).closest('.bundle-info').find('.current-variant .variant-color').attr('style', divColor);
    $(this).closest('.bundle-info').find('.current-variant img').attr('src', imgSrc);
    $(this).closest('.bundle-info').find('.current-variant span').text(spanText);
    $('.set_inputs input[name="properties[' + spanTitle + ']"]').val(spanText);
});

$(document).ready(function() {
    $('.variant-options').each(function() {
        $(this).find('.option-item.active').each(function() {
            let imgSrc = $(this).find('img').attr('src');
            let divColor = $(this).attr('style');
            let spanText = $(this).find('span').text();
            let spanTitle = $(this).closest('.bundle-info').find('.bundle-title').text();
            
            // Update the current variant's image and text within the same bundle-info section
            $(this).closest('.bundle-info').find('.current-variant img').attr('src', imgSrc);
            $(this).closest('.bundle-info').find('.current-variant .variant-color').attr('style', divColor);
            $(this).closest('.bundle-info').find('.current-variant span').text(spanText);
            
            // Set the input value based on the spanTitle in the set_inputs section
            let targetInput = $('.set_inputs input[name="properties[' + spanTitle + ']"]');
            targetInput.val(spanText);
        });
    });

    // Remove inputs with empty values
    $('.set_inputs input').each(function() {
        if ($(this).val().trim() === '') {
            $(this).remove();
        }
    });
});


$('.product-form__input.field_for_color input[type="radio"][value="BUNDLE OF 3 (Red) (15% OFF)"]+label').each(function () {
    $(this).append(`
        <div class="color-swatch-cstm" style="background-color: #662925;">
            <div class="color-swatch__3" style="background-color: #9d1827;"></div>
            <div class="color-swatch__3" style="background-color: #b41b16;"></div>
        </div>
    `);
});

